import React, { useState, useCallback } from "react";
import { useNavigate } from "react-router";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import Header from "src/components/wizard/Header";
import SearchItems from "../ItemLookup/SearchItems";
import { fullWidthDialog } from "src/constants/dialog";
import useMutation from "src/hooks/useMutation";
import useQueryParams from "src/hooks/useQueryParams";
import { ADD_SHIPMENT_ITEMS_MUTATION } from "src/constants/graphql/mutations";
import { GET_SHIPMENT_QUERY } from "src/constants/graphql/queries";

export default function ReceivedItemsModal({ project, onClose }) {
  const [selectedItems, setSelectedItems] = useState(new Set());
  const params = useQueryParams();
  const navigate = useNavigate();
  const shipmentId = params.get("id");
  const receivedItemsSearch = params.get("receivedItemsSearch") || undefined;

  const [addShipmentItem] = useMutation(ADD_SHIPMENT_ITEMS_MUTATION);

  const customVariables = {
    hasImportedAssets: false,
    hideDepletedAssets: false,
    search: receivedItemsSearch,
  };

  const handleToggleItem = useCallback(async (assetId) => {
    // Immediately add the item to the shipment and navigate to it
    try {
      const response = await addShipmentItem({
        variables: {
          assetId,
          shipmentId,
          quantity: 0,
        },
        refetchQueries: [
          { query: GET_SHIPMENT_QUERY, variables: { id: shipmentId } },
        ],
        awaitRefetchQueries: true,
      });

      const shipmentItemId = response.data.addShipmentItems.shipmentItem.id;
      const pathname = window.location.pathname;
      const newParams = new URLSearchParams(location.search);

      newParams.delete("receivedItems");
      newParams.delete("receivedItemsSearch");
      newParams.set("assetId", assetId);
      newParams.set("shipmentItemId", shipmentItemId);
      newParams.set("addShipmentItem", "true");
      
      navigate({ pathname, search: newParams.toString() });
    } catch (error) {
      console.error("Error adding item:", error);
    }
  }, [addShipmentItem, shipmentId, navigate]);

  return (
    <Dialog open fullWidth maxWidth="sm" onClose={onClose} sx={fullWidthDialog}>
      <Box bgcolor="#f4f6f8">
        <Header title="Received Items" />
      </Box>
      <DialogContent
        sx={{
          background: "#f4f6f8",
          px: { xs: 0, sm: 3 },
          pb: 1.5,
        }}
      >
        <Box display="flex" justifyContent="center" px={{ xs: 2, sm: 0 }}>
          <Box
            mx={2}
            component="img"
            borderRadius={3}
            width="100%"
            maxWidth={300}
            minHeight="100px"
            src="/item-lookup.png"
          />
        </Box>
        <Typography fontWeight={400} align="center" fontSize={17} px={{ xs: 2, sm: 0 }}>
          Select the item you received from the list below
        </Typography>
        <Box mt={2}>
          <SearchItems
            project={project}
            assetTypeOverride="Asset"
            closeParam="receivedItems"
            customVariables={customVariables}
            selectedItems={selectedItems}
            onToggleItem={handleToggleItem}
            showCheckboxes={false}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
